import { useTranslation } from "react-i18next";

import { formatDate } from "../../utils/helpers";

import PhoneNumberToDial from "../../Components/PhoneNumberToDial";
import SendEmailButton from "../../Components/SendEmailButton";

import "./style.scss";

const ProviderRequestCard = ({ requesData, button = "" }) => {
  const { t } = useTranslation();

  const ageMap = {
    Child: t("student_age_child"),
    Teen: t("student_age_teen"),
    Adult: t("student_age_adult"),
    Senior: t("student_age_senior"),
  };

  const frequencyMap = {
    OnceAWeek: t("once_week"),
    TwiceAWeek: t("twice_week"),
    MultipleTimesAWeek: t("multiple_time_week"),
    ByInstructorGuidance: t("instructor_guidance"),
    Flexible: t("flexible_schedule"),
  };

  return (
    <div className="requests-card-wraper">
      <div className="card-info">
        <span>{t("name")}:</span>
        <span>{requesData.consumerName}</span>
      </div>
      <div className="card-info">
        <span>{t("age")}:</span>
        <span>{ageMap[requesData.ages]}</span>
      </div>
      <div className="card-info">
        <span>{t("requested_at")}:</span>
        <span>{formatDate(requesData.creationDate, t)}</span>
      </div>
      <div className="card-time-slots">
        <span className="time-slots-header">{t("preferd_time_slots")}</span>
        <div className="slots">
          <span>{frequencyMap[requesData.frequency]}</span>
          <span>{t(requesData.availability.toLowerCase())}</span>
        </div>
      </div>

      {requesData.description === "" ? null : (
        <div className="card-notes">
          <span className="time-notes-header">{t("additional_text")}</span>
          <div className="notes">
            <span>{requesData.description}</span>
          </div>
        </div>
      )}

      {/* contacts */}

      <div className="card-contacts">
        <div className="contact">
          <div className="contact-number">
            <PhoneNumberToDial number={requesData.consumerPhoneNumber} />
          </div>
        </div>
        <div className="contact">
          <div>
            <SendEmailButton email={requesData.consumerEmail} />
          </div>
        </div>
      </div>
      <div className="card-btn">{button}</div>
    </div>
  );
};

export default ProviderRequestCard;
